/* global axios */
import ApiClient from './ApiClient';

class SchedulingAPI extends ApiClient {
  constructor() {
    super('scheduling', { accountScoped: true });
  }

  // Professionals
  getProfessionals(activeOnly = false) {
    return axios.get(`${this.url}/professionals`, {
      params: { active_only: activeOnly || undefined },
    });
  }

  createProfessional(data) {
    return axios.post(`${this.url}/create_professional`, data);
  }

  showProfessional(id) {
    return axios.get(`${this.url}/${id}/show_professional`);
  }

  updateProfessional(id, data) {
    return axios.put(`${this.url}/${id}/update_professional`, data);
  }

  destroyProfessional(id) {
    return axios.delete(`${this.url}/${id}/destroy_professional`);
  }

  // Professional Hours
  getProfessionalHours(id) {
    return axios.get(`${this.url}/${id}/professional_hours`);
  }

  updateProfessionalHours(id, hours) {
    return axios.put(`${this.url}/${id}/update_professional_hours`, { hours });
  }

  // Available Slots
  getAvailableSlots(date, professionalId = null) {
    const params = { date };
    if (professionalId) params.professional_id = professionalId;
    return axios.get(`${this.url}/available_slots`, { params });
  }

  getProfessionalSlots(id, date) {
    return axios.get(`${this.url}/${id}/professional_slots`, {
      params: { date },
    });
  }

  // Bookings
  getBookings(params = {}) {
    return axios.get(`${this.url}/bookings`, { params });
  }

  createBooking(data) {
    return axios.post(`${this.url}/create_booking`, data);
  }

  showBooking(id) {
    return axios.get(`${this.url}/${id}/show_booking`);
  }

  updateBooking(id, data) {
    return axios.put(`${this.url}/${id}/update_booking`, data);
  }

  cancelBooking(id) {
    return axios.post(`${this.url}/${id}/cancel_booking`);
  }

  sendConfirmation(id) {
    return axios.post(`${this.url}/${id}/send_confirmation`);
  }
}

export default new SchedulingAPI();
